import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { ScanLine, Trash2, ChevronDown } from "lucide-react";

const color = (s) => (s >= 80 ? "#00E676" : s >= 50 ? "#FFD700" : "#F87171");

export default function UxAuditPanel() {
  const [audits, setAudits] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/ceo/ux-audit").then(({ data }) => setAudits(data.audits || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const remove = async (a) => { if (!window.confirm("Eliminare questo audit?")) return; try { await api.delete(`/ceo/ux-audit/${a.id}`); load(); } catch (e) {} };

  return (
    <div className="space-y-5" data-testid="ux-audit-panel">
      <div>
        <h2 className="font-display font-bold text-xl flex items-center gap-2"><ScanLine className="h-5 w-5 text-[#00E676]" /> Auto-Audit UX</h2>
        <p className="text-sm text-zinc-500">Punteggio UX Health calcolato su collisioni tra elementi interattivi e overflow orizzontali. Per generare un audit: apri <b>Preview Cliente</b>, naviga la schermata (anche su viewport mobile) e premi <b>Scansiona UX</b> nel banner verde, poi <b>Salva audit</b>.</p>
      </div>
      <div className="space-y-2" data-testid="ux-audit-list">
        {audits.length === 0 && <div className="text-zinc-600 text-sm p-4 rounded-xl bg-[#1C1C1F] border border-white/10">Nessun audit salvato.</div>}
        {audits.map((a) => (
          <div key={a.id} data-testid={`ux-audit-${a.id}`} className="rounded-2xl bg-[#1C1C1F] border border-white/10 p-4">
            <div className="flex items-center gap-3">
              <div className="text-2xl font-black w-12 text-center shrink-0" style={{ color: color(a.score) }}>{a.score}</div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold truncate">{a.route || "/"}</div>
                <div className="text-[11px] text-zinc-600">{a.viewport} · {(a.collisions || []).length} collisioni · {(a.overflows || []).length} overflow · {a.by}</div>
              </div>
              <button data-testid={`ux-audit-toggle-${a.id}`} onClick={() => setOpen(open === a.id ? null : a.id)} className="text-zinc-400"><ChevronDown className={`h-4 w-4 transition-transform ${open === a.id ? "rotate-180" : ""}`} /></button>
              <button data-testid={`ux-audit-del-${a.id}`} onClick={() => remove(a)} className="text-red-400"><Trash2 className="h-4 w-4" /></button>
            </div>
            {open === a.id && (
              <div className="mt-3 text-xs space-y-1 border-t border-white/10 pt-3 max-h-60 overflow-auto">
                {(a.collisions || []).map((c, i) => <div key={`c${i}`} className="text-zinc-500">• {c.a} ↔ {c.b} ({Math.round((c.ratio || 0) * 100)}%)</div>)}
                {(a.overflows || []).map((o, i) => <div key={`o${i}`} className="text-amber-400/80">⇥ overflow: {o.label} (right {o.right}px)</div>)}
                {((a.collisions || []).length + (a.overflows || []).length) === 0 && <div className="text-[#00E676]">Nessun problema rilevato 🎉</div>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
